import { css } from '@linaria/core';

export const styledButton = css`
	--button-color-primary: var(--color-white-xs);
	--button-color-secondary: var(--color-white-solid);
	--button-color-additional: transparent;
	border-width: 2px;
	border-style: solid;
	--additional-padding-x: 0px;
	background-image: linear-gradient(
		0deg,
		var(--color-black-m),
		var(--color-black-m)
	);

	&:hover:not(.disabled, :focus, .selected) {
		--button-color-primary: var(--color-white-m);
	}

	&:focus:not(:active, .selected) {
		--button-color-additional: var(--color-white-solid);
		--button-color-secondary: var(--color-white-solid);
	}

	&:active:not(.selected) {
		--button-color-primary: var(--color-grey-44-solid);
	}
	&.disabled:not(.selected) {
		--button-color-primary: var(--color-white-xs);
		--button-color-secondary: var(--color-grey-52-solid);
	}

	&.selected {
		border-width: 1px;
		--additional-padding-x: 1px;
		--button-color-primary: var(--color-grey-10-solid);
		--button-color-secondary: var(--color-white-solid);
		--button-color-additional: var(--color-white-solid);
	}
`;
